import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WalletResponse } from "reduxStore/dataTypes";

interface WalletState {
  wallet: WalletResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: WalletState = {
  wallet: null,
  loading: false,
  error: null,
};

const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    walletRequest(state) {
      state.loading = true;
      state.error = null;
    },
    walletSuccess(state, action: PayloadAction<WalletResponse>) {
      state.loading = false;
      state.wallet = action.payload;
    },
    walletFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { walletRequest, walletSuccess, walletFailure } =
  walletSlice.actions;
export default walletSlice.reducer;
